import "./UtilsStyles.css"

import Util1 from "../assets/util1.png";
import Util2 from "../assets/util2.png";

import React from 'react'

import { NavLink } from "react-router-dom";

const Utils = () => {
  return (
    
    <div className="utils-container">
        <h1 className="utils-heading">Echa un vistazo a...</h1>
        <div className="util-container">
        
            <NavLink to={"https://arturocodeblog.super.site/recursos"} target={"_blank"}>
            <div className="util-card">
                <img src={Util1} alt="Preview del proyecto"/>
                <h2 className="util-title">Mi lista de recursos web</h2>
            </div>
            </NavLink>

            <NavLink to={"https://arturocode.gumroad.com/"} target={"_blank"}>
            <div className="util-card">
                <img src={Util2} alt="Preview del proyecto"/>
                <h2 className="util-title">Mis plantillas de Notion</h2>
            </div>
            </NavLink>

        </div>       
    </div>
  )
}

export default Utils